import { apiSlice } from "../../app/api/apiSlice";
import { generateFormatedURL } from "../urlFormatter";

export const reportApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // startDetection: builder.query({
    //     query: (workScheduleId: string) => `/report/start?workScheduleId=${workScheduleId}`,
    // }),
    getReport: builder.query<any, any>({
      query: (args) => "/report".concat(generateFormatedURL(args)),
    }),
    getMonthlyReport: builder.query<Blob, { yearstr: string; monthstr: string }>({
      query: (args) => ({
        url: "/report/monthly".concat(generateFormatedURL(args)),
        responseHandler: async (response) => response.blob(),
      }),
    }),
    getWeeklyReport: builder.query<Blob, { from: string; to: string }>({
      query: (args) => ({
        url: "/report/weekly".concat(generateFormatedURL(args)),
        responseHandler: async (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useLazyGetReportQuery,
  useLazyGetMonthlyReportQuery,
  useLazyGetWeeklyReportQuery,
} = reportApiSlice;
